import React, { useState } from "react";
import { Box, Typography, Button, useTheme, useMediaQuery } from "@mui/material";
import LoanAppForm from "@/modules/customer/components/LoanApplicationForm";
import LoginPopup from "@/common/LoginPopup";

export default function PreapprovalApplication({ VendorDetail }) {
  const [loanApplicationModalOpen, setLoanApplicationModalOpen] = useState(false);
  const isAuthenticated = Boolean(localStorage.getItem("access_token"))
  const theme = useTheme();
  const isNarrow = useMediaQuery("(max-width:991px)");
  const [showPopup, setShowPopup] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");

  const handleAction = () => {
    if (!isAuthenticated) {
      setRedirectUrl("/customer/auth/login");
      setShowPopup(true);
    } else {
      setLoanApplicationModalOpen(true);
    }
  };

  return (
    <>
      <Box
        component="section"
        sx={{
          bgcolor: "#fbfcff",
          border: "1px solid #d9d9d9",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          mt: 1,
          p: isNarrow ? "24px 20px" : "8px 80px 20px 38px",
          fontFamily: `"Poppins", ${theme.typography.fontFamily}`,
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography variant="h6" fontWeight={600}>
            Initiate Preapproval
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#6e6d6a",
              fontSize: 16,
              fontWeight: 400,
            }}
          >
            Get started by telling us a bit about your home loan needs
          </Typography>
        </Box>

        <Box
          sx={{
            width: isNarrow ? "100%" : "auto",
            mt: 1,
            display: "flex",
            justifyContent: "center", // center the button in its container
            alignSelf: isNarrow ? "stretch" : "flex-start", // full width on narrow, otherwise auto
          }}
        >
          <Button
            variant="contained"
            onClick={handleAction}
            sx={{
              backgroundColor: "#5e5acf",
              textTransform: "uppercase",
              borderRadius: "6px",
              py: 1,
              px: 3,
              fontSize: { xs: "14px", sm: "16px" }, // responsive font
              fontWeight: 600,
              lineHeight: 1,
              minWidth: { xs: "auto", sm: "140px", md: "160px", lg: "450px" }, // responsive minWidth
              "&:hover": { backgroundColor: "#4b4bbf" },
            }}
          >
            Get Started
          </Button>
        </Box>

        {loanApplicationModalOpen && (
          <LoanAppForm
            open={loanApplicationModalOpen}
            onClose={() => setLoanApplicationModalOpen(false)}
            venderdetail={VendorDetail}
          />
        )}
      </Box>
      {showPopup && (
        <LoginPopup
          onClose={() => setShowPopup(false)}
          redirectUrl={redirectUrl}
        />
      )}</>
  );
}
